import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function transferRecordList(data) { return axios.post(`${base.url}/payment/transferRecord/list`, qs.stringify(data)) }
export function transferRecordStats() { return axios.post(`${base.url}/payment/transferRecord/stats`) }
export function transferRecordGroups() { return axios.post(`${base.url}/payment/transferRecord/groups`) }
export function transferRecordDetail(id) { return axios.post(`${base.url}/payment/transferRecord/detail`, qs.stringify({ id })) }
export function transferRecordExport(data) { return axios.post(`${base.url}/payment/transferRecord/export`, qs.stringify(data), { responseType: 'blob' }) }
